import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { ReactNode } from 'react';
import { ArticleBodytext, ArticleBodytextProps } from './ArticleBodytext';

export interface StandaloneArticleBodytextProps extends StandaloneComponentProps {
  content?: ReactNode;
  options?: ArticleBodytextProps;
}

export const StandaloneArticleBodytext: StandaloneComponent<StandaloneArticleBodytextProps> = ({
  content,
  options,
  ...props
}) => {
  const { ...baseProps } = options ?? {};

  return (
    <ArticleBodytext {...baseProps} {...props}>
      {content}
    </ArticleBodytext>
  );
};

export default StandaloneArticleBodytext;
